<template>
  <section class="flex column">
    <!-- filters -->
    <div class="flex-1 w100">
      <div class="flex end filters-group-holder">
        <div style="margin-right: 16px;" class="flex column no-mobile">
            <label>Atualizar dados</label>
            <div class="flex end w100" style="margin-top:12px">
              <div @click="forceRefreshData()" class="button secondary">
                <i class="fas fa-sync-alt"></i>
              </div>
            </div>
          </div>

        <ltk-date-picker
          label="Filtro de data"
          v-model="filters.data.date"
          :loading="loading"
        ></ltk-date-picker>
      </div>
    </div>

    <!-- big card -->
    <div class="flex-1 w100 margin-to-l">
      <div class="">
        <h3>Vendas</h3>
      </div>
      <div class="grid-flex wrap">
        <div class="item flex-1 center-txt">
          <div class="box margin-top-l primary-bg">
            <div
                class="box-content custom-card w100"
                :class="{ negative: stats.profit < 0 }"
              >
              <div class="flex row">
                <div class="flex-2">
                  <h1 class="margin-top-s">{{ stats.profit | money }}</h1>
                  <span>Lucro líquido</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="item flex-1 center-txt">
          <div class="box margin-top-l">
            <div class="box-content custom-card">
              <div class="flex row">
                <div class="flex-1">
                  <h1 class="margin-top-s">
                    {{ stats.receita_bruta | money }} ({{
                      stats.sales | number
                    }})
                  </h1>
                  <span class="title">Receita Bruta</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="item flex-1 center-txt">
          <div class="box margin-top-l">
            <div class="box-content custom-card">
              <div class="flex row">
                <div class="flex-1">
                  <h1 class="margin-top-s">
                    {{ stats.receita_liquida | money }} ({{
                      stats.approved_sales_count | number
                    }})
                  </h1>
                  <span class="title">Receita Líquida</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="false" class="grid-flex wrap w100">
      <div class="item flex-1 center-txt">
        <div class="box2 margin-top-l ">
          <div class="box-content2 custom-card">
            <div class="flex row">
              <custom-line
                class="margin-top-l w100"
                :data="chartDataPolar.data"
              ></custom-line>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="grid-flex w100 column margin-top-l no-mobile">
      <div class="">
        <h3>Funil de conversão</h3>
      </div>
      <div ref="divcontainer" class="item flex-1 center-txt w100">
        <div class="box margin-top-l ">
          <div class="box-content custom-card">
            <div class="flex row">
              <vue-funnel-graph
                v-if="funnelData.values && funnelData.values.length > 0"
                :width="funnelData.width"
                :height="funnelData.height"
                :labels="funnelData.labels"
                :values="funnelData.values"
                :colors="funnelData.colors"
                :sub-labels="funnelData.subLabels"
                :direction="funnelData.direction"
                :gradient-direction="funnelData.gradientDirection"
                :animated="true"
                :display-percentage="true"
              ></vue-funnel-graph>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- cards -->
    <div class="flex-1 margin-top-l w100">
      <div class="">
        <h3>Resumo Financeiro</h3>
      </div>
      <div class="grid-flex wrap">
        <div class="item flex-1">
          <box-info
            icon="fas fa-dollar-sign"
            label="Receita Bruta USD"
            tooltip="Receita bruta de vendas em USD. Essa receita está contida na Receita Bruta Geral, o valor em USD é convertido para BRL útilizando o valor da cotação do período"
            :value="stats.sum_dollar"
            :money="true"
            currency="USD"
          >
          </box-info>
        </div>

        <div class="item flex-1">
          <box-info
            icon="fas fa-dollar-sign"
            label="Receita Comissão USD"
            tooltip="Receita de comissão de vendas em USD. Essa receita está contida na Receita Bruta Geral, o valor em USD é convertido para BRL útilizando o valor da cotação do período"
            :value="stats.sum_commission_dollar"
            :money="true"
            currency="USD"
          >
          </box-info>
        </div>

        <div class="item flex-1">
          <box-info
            icon="fas fa-dollar-sign"
            label="Cotação USD"
            tooltip="Cotação de USD para BRL útilizada na conversão"
            :value="stats.quotation_usd_to_brl"
            :money="true"
          >
          </box-info>
        </div>

        <div class="item flex-1">
          <box-info
            icon="fas fa-box"
            label="Custo Produtos"
            tooltip="Somatório de custos de produtos para pedidos APROVADOS"
            :value="stats.cost_product"
            :money="true"
          >
          </box-info>
        </div>

        <div class="item flex-1">
          <box-info
            icon="fas fa-bullhorn"
            label="Custo de Marketing"
            tooltip="Somatório de custos de campanhas ATIVAS"
            :value="stats.cost_marketing"
            :money="true"
          >
          </box-info>
        </div>

        <div class="item flex-1">
          <box-info
            icon="fas fa-balance-scale"
            label="Taxas e Impostos"
            tooltip="Somatórios de taxas do checkout, gateway e impostos dos pedidos APROVADOS"
            :value="stats.cost_tax_and_impost"
            :money="true"
          >
          </box-info>
        </div>

        <div class="item flex-1">
          <box-info
            icon="fas fa-dollar-sign"
            label="Ticket Médio"
            tooltip="Receita Líquida / Número de pedidos APROVADOS"
            :value="stats.avg_ticket"
            :money="true"
          >
          </box-info>
        </div>

        <div class="item flex-1">
          <box-info
            icon="fas fa-box"
            label="Margem de lucro"
            tooltip="Lucro Líquido / Receita Liquida"
            :value="stats.percent_profit"
            suffix="%"
          >
          </box-info>
        </div>

        <div class="item flex-1">
          <box-info
            icon="fas fa-bullhorn"
            label="CPA"
            tooltip="Custo de Aquisição (Custo de Marketing / Número de pedidos aprovados)"
            :value="stats.cpa"
            :money="true"
          >
          </box-info>
        </div>

        <div class="item flex-1">
          <box-info
            icon="fas fa-balance-scale"
            label="ROAS"
            tooltip="Retorno Sobre Investimento (Receita Líquida) / (Somatório de marketing)"
            :value="stats.roas"
            suffix="X"
          >
          </box-info>
        </div>

        <div class="item flex-1">
          <box-info
            icon="fas fa-balance-scale"
            label="ROI"
            tooltip="Retorno Sobre Investimento (Receita Líquida - Somatório de custos) / (Somatório de custos)"
            :value="stats.roi"
            suffix="%"
          >
          </box-info>
        </div>

        <div class="item flex-1">
          <box-info
            icon="fas fa-balance-scale"
            :label="
              `Pedidos Aprovados (${$filters.number(
                stats.approved_sales_count
              )})`
            "
            tooltip="Receita de pedidos aprovados"
            :value="stats.approved_sales_sum"
            :money="true"
          >
          </box-info>
        </div>

        <div class="item flex-1">
          <box-info
            icon="fas fa-balance-scale"
            :label="
              `Pedidos Pendentes (${$filters.number(
                stats.await_payment_sales_count
              )})`
            "
            tooltip="Receita de pedidos pendentes"
            :value="stats.await_payment_sales_sum"
            :money="true"
          >
          </box-info>
        </div>

        <div class="item flex-1">
          <box-info
            icon="fas fa-dollar-sign"
            label="Conversão Boleto"
            tooltip="Número de boletos pagos / Número de boletos gerados"
            :value="stats.conv_billet"
            suffix="%"
          >
          </box-info>
        </div>
      </div>

      <div class="flex-1 margin-top-l no-mobile">
        <div class="">
          <h3>Detalhamento por Dia</h3>
        </div>
      </div>
      <!-- graph days -->
      <div class="flex-1 no-mobile">
        <div class="box margin-top-l">
          <div class="box-content">
            <bar-chart
              v-if="
                chartDataLine.data.datasets &&
                  chartDataLine.data.datasets.length > 0
              "
              class="margin-top-l"
              :height="140"
              :chartData="chartDataLine.data"
              :options="chartDataLine.options"
              :limit="30"
              color="green"
            ></bar-chart>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { getProfit } from "@/services/profit";
import { getProduct } from "@/services/product.js";

import barChart from "@/components/charts/barChart";
import boxInfo from "@/components/boxInfo/BoxInfo";

import ltkDatePicker from "@/components/datepicker/LtkDatePicker";
import customLine from "@/modules/dash/customLine";
import { VueFunnelGraph } from "vue-funnel-graph-js";

import moment from "moment";
moment.locale("pt-br");

import { mapState } from "vuex";

const emptyData = {
  profit: "-",
  sales: "-",
  receita_bruta: "-",
  receita_liquida: "-",
  cost_product: "-",
  cost_marketing: "-",
  cost_tax_and_impost: "-",
  conv_billet: "-",
  avg_ticket: "-",
  percent_profit: "-",
  cpa: "-",
  roi: "-",
  approved_sales_count: "-",
  approved_sales_sum: "-",
  await_payment_sales_count: "-",
  await_payment_sales_sum: "-",
  sum_dollar: "-",
  sum_commission_dollar: "-",
};
export default {
  name: "product-detail",
  components: {
    barChart,
    customLine,
    ltkDatePicker,
    VueFunnelGraph,
    boxInfo,
  },
  props: ["product_id"],
  data() {
    return {
      loading: false,
      currentTab: "report",
      productTabs: [
        {
          name: "report",
          title: "Relatório",
        },
        {
          name: "ads",
          title: "Campanhas",
        },
      ],
      product: {},
      stats: emptyData,
      filters: {
        data: {
          date: [
            moment()
              .add(-0, "d")
              .startOf("day")
              .toDate(),
            moment()
              .startOf("day")
              .toDate(),
          ],
        },
        list: {},
      },
      chartDataLine: {
        options: {},
        data: {
          labels: [],
          datasets: [],
        },
      },
      chartDataPolar: {
        data: {
          Cartão: "-",
          Pix: "-",
          Boleto: "-",
        },
      },
      funnelData: {
        labels: [
          // "Impressions",
          "Page View",
          "Add To Cart",
          "Initiate checkout",
          "Add Payment info",
          "Purchase",
        ],
        subLabels: [],
        values: [],
        colors: [
          ["#47265a", "#000"], // color set for "Impressions" segment
          ["#A0BBFF", "#EC77FF"], // color set for "Add To Cart" segment
          ["#A0F9FF", "#7795FF"], // color set for "Buy" segment
        ],
        direction: "horizontal",
        gradientDirection: "horizontal",
        height: 300,
        width: 1024,
      },
      refreshTime: 60,
      refreshInterval: null,
    };
  },
  created() {
    window.addEventListener("resize", this.calculateWidthSizeChart);
  },
  destroyed() {
    window.removeEventListener("resize", this.calculateWidthSizeChart);
    clearInterval(this.refreshInterval)
  },
  mounted() {
    this.calculateWidthSizeChart();

    this.getReport();
    this.getProduct();

    this.refreshInterval = setInterval(this.getReport, this.refreshTime * 1000)

  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
  },
  watch: {
    "filters.data": {
      deep: true,
      handler() {
        this.stats = emptyData;
        this.getReport();
      },
    },
  },
  methods: {
    forceRefreshData() {
      this.stats = emptyData;
      this.getReport();
    },
    calculateWidthSizeChart() {
      var w = window.innerWidth;

      //vamos ocupar todo o width do parent
      // e manter a proporcao do ecra de 4:1
      var parentWidth = this.$refs.divcontainer.parentElement.clientWidth;
      var itemHeight = parentWidth / 4.0;

      if (w <= 768) {
        this.width = 300;
        this.height = 800;
        this.direction = "vertical";
        this.gradientDirection = "vertical";
      }

      if (w === 768) {
        this.width = 500;
        this.height = 300;
        this.direction = "horizontal";
        this.gradientDirection = "horizontal";
      }

      if (w <= 1024 && w > 768) {
        this.width = 800;
        this.height = 300;
        this.direction = "horizontal";
        this.gradientDirection = "horizontal";
      }

      if (w > 1024) {
        this.width = parentWidth;
        this.height = itemHeight;
        this.direction = "horizontal";
        this.gradientDirection = "horizontal";
      }
    },
    checkResource(name) {
      return this.account && this.account.resources.includes(name);
    },
    getReport() {
      this.loading = true;

      const date = this.filters.data.date;
      let params = {
        start_date: date[0] ? date[0].toISOString().slice(0, 10) : "",
        end_date: date[1] ? date[1].toISOString().slice(0, 10) : "",
        product_id: this.product_id,
      };

      getProfit(params)
        .then((result) => {
          this.stats = result.stats;

          this.chartDataPolar = result.bar_line;

          // format graph
          this.chartDataLine.data.labels = result.graph_day.labels;
          let auxDataset = [];

          result.graph_day.data.forEach((d) => {
            auxDataset.push({
              label: d.label,
              data: d.data,
            });
          });

          this.chartDataLine.data.datasets = auxDataset;

          // funnel

          // subLabels: ["FaceBook", "Google Ads", "Tik Tok Adss"],

          console.log("result.funnel_marketing", result.funnel_marketing);

          this.funnelData.subLabels = result.funnel_marketing.sublabels;
          this.funnelData.labels = result.funnel_marketing.labels;
          this.funnelData.values = result.funnel_marketing.values;
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um problema ao buscar dados",
          });
        })
        .finally(() => {
          this.loading = false;
          this.data = emptyData;
        });
    },
    getProduct() {
      getProduct(this.product_id)
        .then((result) => {
          this.product = result;
          // update breadcrumb to name produto
          this.$store.dispatch("setBreadcrumb", {
            idx: 1,
            name: result.name,
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um problema ao buscar produto",
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.filters-group-holder {
  position: sticky;
  top: -1px;
  z-index: 4;

  &[stuck] {
    background: var(--bg);
    padding: 35px 5px 15px 5px;
  }
}

.custom-card {
  min-width: 250px;
  .big-icon {
    i {
      color: var(--primary);
      font-size: 28px;
    }
  }
  .title {
    white-space: nowrap;
  }
  h3 {
    font-size: 22px;
    white-space: nowrap;
  }
  h1 {
    font-size: 26px;
    // color: var(--secondary);
  }
  &.negative {
    h1 {
      color: #fff !important;

    }
  }
}
.primary-bg {
  background: var(--primary);

  h1 {
    font-size: 26px;
    color: #fff;
  }

  span {
    color: #fff;
  }
}
</style>

<style lang="scss">
.svg-funnel-js .svg-funnel-js__labels .svg-funnel-js__label {
  .label__title {
    // color: var(--text) !important;
    color: #000 !important;
  }

  .label__percentage {
    color: #fff !important;
    margin-top: 8px;
    padding: 5px;
    background: var(--primary);
    border-radius: 32px;
    width: 50%;
  }
}

.svg-funnel-js:not(.svg-funnel-js--vertical)
  .svg-funnel-js__label:not(:first-child) {
  border-left: 1px solid #722e2e1f !important;
}

.svg-funnel-js .svg-funnel-js__labels .svg-funnel-js__label .label__value {
  color: var(--text);
}

.svg-funnel-js .svg-funnel-js__subLabels {
  display: none;
}

.svg-funnel-js__label {
  align-content: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.svg-funnel-js
  .svg-funnel-js__labels
  .svg-funnel-js__label:hover
  .label__segment-percentages {
  display: none !important;
}
</style>
